export enum TYPE_COMPETENCE {
	MACHINISTE = 'MACHINISTE',
	PARTICIPANT = 'PARTICIPANT'
}
